<template>
  <div class="kpi-achieve-detail-page">
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="2">
      <van-tab v-for="(title) in types" :key="title.title" :title="title.title">
        <van-list v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —">
          <div class="customer">
            <div class="item bottom-line" v-for="(item,index) of customerList" :key="index">
              <img class="img" :src="item.avatar || 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'" alt="" />
              <div class="customer-info">
                <div class="top">
                  <p class="f1 ofh f fc" v-if="rankType=='view'||rankType=='fission'">
                    <span>{{item.nickname}}</span>
                    <span v-if="item.mobile">({{item.mobile}})</span>
                  </p>
                  <p class="f1 ofh f fc" v-else>
                    <span>{{item.name}}</span>
                    <span v-if="item.mobile">({{item.mobile}})</span>
                  </p>
                  <span>{{item.happenTime}}</span>
                </div>
                <div class="center">
                  <div class="f f-v lh15">
                    <p class="f fc">邀请人：<span style="margin-right:10px;color:#1890FF;">{{item.bsNickname}}</span></p>
                    <p class="f fc" v-if="item.blNickname">归属导购员：<span style="margin-right:10px;color:#1890FF;">{{item.blNickname||0}}</span></p>
                  </div>
                  <p style="color:#FF6060;">+ {{item.bonusAmount||0}}</p><!-- 奖励金额 -->
                </div>
                <div class="bottom" v-if="rankType=='card'">
                  <p>购卡卡金额：{{item.payAmount||0}}元</p>
                </div>
                <div class="bottom" v-if="rankType=='seckill_user'">
                  <p>秒杀金额：{{item.payAmount||0}}元</p>
                </div>
                <div class="bottom" v-if="rankType=='live_order_cus'">
                  <p><span>订单数：{{item.orderNum}}</span><span>下订金额：{{item.payAmount||0}}元</span></p>
                </div>
              </div>
            </div>
          </div>
        </van-list>

      </van-tab>
    </van-tabs>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
// import appFooter from '../../components/kpi-footer/index.vue';
import backHome from '../../components/back-home.vue';

export default {
  components: {
    // appFooter,
    backHome
  },
  data() {
    return {
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      title: this.$route.query.title,
      rankType: this.$route.query.type,//业绩类型
      typeIndex: 0,
      types: [
        { title: `${this.$route.query.title}客户` }
      ],
      params: {
        index: 1,
        size: 50,
        loading: false,
        finished: false,
      },
      customerList: [], // 有效客户列表
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = this.title;
    this.getList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取客户列表
    getList() {
      this.params.loading = true;
      this.$kpi.achieve.getMyCustomerList({
        "actId": Number(this.activity_id),
        "kpiUserId": this.kpi_userid || null,
        "page": -1,
        "size": -1,
        "type": this.rankType
      }).then(res=>{
        console.log(res)
        this.params.loading = false;
        if(res.code==0){
          var data=res.data;
          this.types[0].title = `${this.title}客户（${data.leftCount||0}）`;
          this.customerList = data.leftCustomerInfoVos || [];
          this.params.finished = true;
        }else if(res.code==10200){
          this.types[0].title = `${this.title}客户（0）`;
          this.params.finished=true;
        }
      });
    },
  }
};

</script>

<style lang="less" scoped>
.kpi-achieve-detail-page {
  height: 100vh;
  .customer{
    .item{
      display: flex;
      padding: 8px 15px;
      background: #fff;
      .img{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .customer-info{
        flex: 1;
        overflow: hidden;;
        display: flex;
        flex-direction: column;
        .top,
        .center,
        .bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 6px 0;
        }
      }
    }
  }
}

</style>
